import React from 'react';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';

import { handleOnClick } from '../../../../../../utils/handle-on-click';
import { type ActionDropdownItemProps } from './types';

const ActionDropdownItem = ({
	content,
	iconAfter,
	iconBefore,
	isLoading,
	onClick,
	testId,
}: ActionDropdownItemProps): React.JSX.Element => (
	<DropdownItem
		elemAfter={iconAfter}
		elemBefore={iconBefore}
		isDisabled={isLoading}
		onClick={handleOnClick(onClick)}
		testId={testId}
	>
		{content}
	</DropdownItem>
);

export default ActionDropdownItem;
